import { JDSCarouselPaginationItemProps } from './generated/interface';

type Props = JDSCarouselPaginationItemProps & {
  internalIndex: number;
  internalClasses?: string;
};

export const withLogic =
  (Component: React.ComponentType<Props>): React.FC<Props> =>
  (props: Props) => {
    return (
      <Component
        {...{
          ...props,
          onDotClick: () => props.onDotClick?.(props.internalIndex as any),
          className: props.internalClasses
        }}
      />
    );
  };
